module.exports = __webpack_public_path__ + "static/media/logo-light.c92b7f55.svg";